module.exports = __webpack_public_path__ + "img/Fondo_Pantalla_intermedio.53040a19.png";